import { Option } from '@/common/types/option'

export const stateOptions: Option[] = [
  { value: 'registered', label: 'Cadastrou o estabelecimento' },
  { value: 'qualifying', label: 'Iniciou Qualificação' },
  { value: 'qualifying_client_changes_requested', label: 'Solicitou revisão aos representantes' },
  { value: 'qualifying_quote_client_review', label: 'Enviou condição comercial para cliente' },
  { value: 'qualifying_review', label: 'Iniciou análise credencial' },
  { value: 'qualifying_quote', label: 'Aprovado para etapa de condição comercial' },
  { value: 'deploying', label: 'Cliente aprovou condição comercial' },
  { value: 'deploying_management_review', label: 'Condição comercial aprovada pelo cliente' },
]
